<template>
  <div class="login-form">
    <b-form @submit.prevent="handleSubmit">
      <NanInput
        v-model="username"
        :validation="$v.username"
        prependIcon="icon-user"
        placeholder="Username or email"
        aria-label="Username or email"
        class="mb-2"
      />

      <NanInput
        v-model="password"
        :validation="$v.password"
        type="password"
        prependIcon="icon-lock"
        placeholder="Password"
        aria-label="Password"
        class="mb-2"
      />

      <b-button
        id="login-submit-login"
        :class="{ disabled: $v.$invalid || $store.state.pendingRequests }"
        variant="primary"
        type="submit"
        class="px-4"
        block
        >Log In</b-button
      >

      <b-button
        id="login-password-forgot_password"
        to="/login/forgot"
        variant="link"
        class="px-0"
        block
        >Forgot password?</b-button
      >
    </b-form>
    <div class="divider">or</div>
    <b-btn
      :to="{ name: 'Register', query: $route.query }"
      variant="orange"
      block
    >
      Create an Account
    </b-btn>
    <OAuthButtons :highlight="oauthHighlight" />

    <b-btn :to="{ name: 'SSO', query: $route.query }" variant="link" block>
      Sign in with SSO
    </b-btn>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import OAuthButtons from "@/components/OAuthButtons";

export default {
  components: {
    OAuthButtons
  },

  mixins: [validationMixin],

  data: () => ({
    username: "",
    password: "",
    oauthHighlight: null
  }),

  methods: {
    async handleSubmit() {
      if (this.$v.$invalid || this.$store.state.pendingRequests) {
        this.$v.$touch();
        return;
      }

      const res = await this.$store.dispatch("user/login", {
        login: this.username,
        pass: this.password
      });

      // OAuth-only accounts return PLEASE_SIGN_IN_WITH_<PROVIDER>
      const code = (res && res.error && res.error.code) || "";
      const match = /^PLEASE_SIGN_IN_WITH_(\w+)$/.exec(code);
      this.oauthHighlight = match ? match[1].toLowerCase() : null;
    }
  },

  validations: {
    username: { required },
    password: { required }
  }
};
</script>
